import React, { useState, useRef, useContext } from 'react'
import { AccountContext } from 'context'
import UserSelect from 'view/components/userSelect'
import util from 'meinian-package/src/utils/util'
import qs from 'qs'
import { getTeamInfo } from 'meinian-package/src/common/userInfo'
import { SwitchPageTab } from '../../../components/switchTab'
import Dynamic from './dynamic'
import Analysis from './analysis'
import AnalysisFilter from './analysisFilter'
import CustomizeHeader, { CustomizeHeaderLeftDefault } from '../../../components/header/customizeHeader'
import styles from './index.module.less'

const TABS = { DYNAMIC: 1, ANALYSIS: 2 }
const TAB_OPTIONS = [{ label: '选款动态', value: TABS.DYNAMIC }, { label: '选款分析', value: TABS.ANALYSIS }]

export default () => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const teamInfo = getTeamInfo()
  const account = useContext(AccountContext)
  const [tab, setTab] = useState(TABS.DYNAMIC)

  const authAdmin = [1, 2].includes(Number(teamInfo.memberType))// 不是超级管理员和管理员的时候

  const [baseParams, setBaseParams] = useState({
    userId: authAdmin ? query.userId ? +query.userId : null : account.userInfo.userId,
  })

  const dynamicRef = useRef(null)
  const analysisRef = useRef(null)

  const _onChange = (valueObj) => {
    setBaseParams(pre => ({ ...pre, ...valueObj }))
  }

  const fetchData = (val) => {
    dynamicRef.current?.fetchCollectData?.({ ...baseParams, ...val })
    dynamicRef.current?.fetchMemberStatisticsData?.({ ...baseParams, ...val })
    dynamicRef.current?.fetchMemberContributeData?.({ ...baseParams, ...val })
    dynamicRef.current?.fetchCheckData?.({ ...baseParams, ...val })
    dynamicRef.current?.fetchNewCollectData?.({ ...baseParams, ...val })
  }

  const onTab = (val) => {
    setTab(val)
    setBaseParams({
      userId: authAdmin ? query.userId ? +query.userId : null : account.userInfo.userId,
    })
    window.scrollToTop()
  }

  console.log('baseParams', baseParams)

  return (<>
    <CustomizeHeader
      hiddenSearch
      renderLeft={() => <CustomizeHeaderLeftDefault
        paths={[{
          name: '工作台',
          path: '/home/workbench/index'
        }, {
          name: '选款分析',
          path: null
        }
        ]}
      />}
    />
    <div className={styles['analysis-container']}>
      <div className="header" id="mn-analysis-container">
        <SwitchPageTab
          value={tab}
          options={TAB_OPTIONS}
          onChange={(val, current) => {
            util.track('mn-header-link', {
              module1: '侧边栏',
              module2: '选款分析',
              module3: current.label,
            })
            onTab(val)
          }}
          renderRight={() => <div>{
            tab === TABS.DYNAMIC ? <ChooseFilter
              baseParams={baseParams}
              authAdmin={authAdmin}
              onChange={value => {
                fetchData({ userId: value })
                _onChange({ userId: value })
              }}
            /> : <AnalysisFilter
              authAdmin={authAdmin}
              value={baseParams}
              onChange={(val) => {
                analysisRef.current?.fetchSourceData?.({ ...baseParams, ...val })
                analysisRef.current?.fetchSourceStyleData?.({ ...baseParams, ...val })
                _onChange(val)
              }}
            />
          }</div>}
        />
      </div>
      <div style={{ marginTop: '24px' }}>
        {tab === TABS.DYNAMIC && <Dynamic baseParams={baseParams} ref={dynamicRef} />}
        {tab === TABS.ANALYSIS && <Analysis ref={analysisRef} baseParams={baseParams} />}
      </div>
    </div>
  </>)
}

const ChooseFilter = ({ authAdmin, baseParams, onChange }) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>
    {
      authAdmin && <UserSelect
        trigger="click"
        placeholder="所有人"
        container={document.body}
        value={baseParams.userId}
        onChange={value => onChange(value)}
      />
    }
  </>
}
